import React from 'react';
import Header from "../../Header/Header";
import { headerObjSix } from "../../Header/HeaderData";
import CC from "./../../../images/team/profasish.jpg";
import CL from "./../../../images/team/akhil.png";
import CCC1 from "./../../../images/team/2d.png";
import CCC2 from "./../../../images/team/agni.png";
import CCC3 from "./../../../images/team/ritwik.png";
import CCC4 from "./../../../images/team/priyam.png";
import Pres from "./../../../images/team/akhilcl.png";
import Chair from "./../../../images/team/eb2.png";
import Director from "./../../../images/team/eb4.png";
import VP from "./../../../images/team/eb7.png";
import Sec from "./../../../images/team/eb5.png";
import Tech from "./../../../images/team/eb11.png";
import Event from "./../../../images/team/eb8.png";
import HoM from "./../../../images/team/susmita.png";
import PR from "./../../../images/team/vijay.png";
import Design from "./../../../images/team/ph.png";

function Team19() {
    return (
        <div>
            <Header {...headerObjSix} />
            <div className="board-category1">
                <div className="category-title">Core.</div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={CC} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Prof. Asish K. Dalai</div>
                    <div className="mcard-title">Club Coordinator (Faculty)</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={CL} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Akhil Surendran</div>
                    <div className="mcard-title">Community Leader</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={CCC1} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Dedipyaman Das</div>
                    <div className="mcard-title">Club Captain</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={CCC2} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Agnibha Chatterjee</div>
                    <div className="mcard-title">Club Captain</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={CCC3} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Ritwik Badola</div>
                    <div className="mcard-title">Club Captain</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={CCC4} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Priyam Sahoo</div>
                    <div className="mcard-title">Club Captain</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Pres} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Krishna Akhil A.</div>
                    <div className="mcard-title">President</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Chair} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Somsubro Banerjee</div>
                    <div className="mcard-title">Chairman</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Director} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Uday Shankar</div>
                    <div className="mcard-title">Director</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={VP} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Jayat Saha</div>
                    <div className="mcard-title">Vice President</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Sec} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Manju Bhargavi</div>
                    <div className="mcard-title">Secretary</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Tech} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Rahul P</div>
                    <div className="mcard-title">Technical Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="board-category3">
                <div className="category-title">Events.</div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={Event} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Datta Adithya</div>
                    <div className="mcard-title">Event Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={HoM} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Susmita Pal</div>
                    <div className="mcard-title">Head of Marketing</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={PR} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">S Vijay Balaji</div>
                    <div className="mcard-title">Head, Public Relations</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="board-category4">
                <div className="category-title">Design.</div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={Design} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Glen Paulson</div>
                    <div className="mcard-title">Head of Design</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team19;
